import { FormControl, ValidationErrors } from '@angular/forms';

export function RegexValidator(control: FormControl, acceptRegex: string, validationKey?: string, validationValue?: string): ValidationErrors | null {
  let result: ValidationErrors = null;
  if (control.value && control.value.length > 0) {
    const found = new RegExp(acceptRegex).test(control.value);
    if (!found) {
      result = {};
      if (validationKey) {
        result[validationKey] = "";
        if (validationValue) {
          result[validationKey] = validationValue;
        }
      } else {
        result = {
          validationError: control.value
        }
      }
    }
  }
  return result;
};
